module.exports = __webpack_public_path__ + "static/img/bkjbz1.b32011f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/bkjbz1.png
// module id = SDhr
// module chunks = 0